import * as Yup from 'yup';

export const useFormLoginClienteValidation = () => {
  const FormLoginYupValidation = Yup.object().shape({
    usuario: Yup.string()
      .required('Este campo é obrigatório.')
      .min(3, 'Deve conter no mínimo 3 caracteres.'),
  });

  return {
    FormLoginYupValidation
  };
};
